import { AggregationField } from 'widgets/portfolioSummary/aggregation/fields/aggregationFieldPortfolio';

export interface PortfolioSummaryAggregatedDataGroup {
    groupName: string;
    total: PortfolioSummaryAggregationItem;
    buy: PortfolioSummaryAggregationItem;
    sell: PortfolioSummaryAggregationItem;
    short?: PortfolioSummaryAggregationItem;
    net: PortfolioSummaryAggregationItem;
    drillDowns?: { [drillDownField: string]: PortfolioSummaryAggregatedData };
}

export interface PortfolioSummaryAggregationItem {
    count: number;
    orderQty: number;
    tradedQty: number;
    leavesQty: number;
    orderedValue: number;
    tradedValue: number;
    leavesValue: number;
    selectionDisabled?: boolean;
}

export const initialPortfolioSummaryAggregationBySide: PortfolioSummaryAggregationItem =
    {
        count: 0,
        orderQty: 0,
        tradedQty: 0,
        leavesQty: 0,
        orderedValue: 0,
        tradedValue: 0,
        leavesValue: 0,
    };

export const initialiseGroup: (
    groupName: string,
    combineSellsAndShorts: boolean
) => PortfolioSummaryAggregatedDataGroup = (
    groupName,
    combineSellsAndShorts
) => ({
    groupName,
    total: {
        ...initialPortfolioSummaryAggregationBySide,
    },
    buy: { ...initialPortfolioSummaryAggregationBySide },
    sell: { ...initialPortfolioSummaryAggregationBySide },
    short: combineSellsAndShorts
        ? undefined
        : { ...initialPortfolioSummaryAggregationBySide },
    net: {
        ...initialPortfolioSummaryAggregationBySide,
    },
});

export type PortfolioSummaryAggregatedData = {
    [groupName: string]: PortfolioSummaryAggregatedDataGroup;
};

export interface PortfolioSummaryDataState {
    /*
     * Aggregated data for the aggregation fields of all widgets in the layout
     */
    aggregatedData: {
        [aggregationField: string]: PortfolioSummaryAggregatedData;
    };
    /*
     * Aggregation fields that have been used by widgets in this layout during the current session
     * Used by getRequiredOrderColumns so that when the user changes the aggregation field,
     * the previous aggregation field remains in the stream - improving performance if the user switches back again
     */
    streamingAggregationFields: AggregationField[];
}

export const initialPortfolioSummaryDataState: PortfolioSummaryDataState = {
    aggregatedData: {},
    streamingAggregationFields: [],
};
